import { render, staticRenderFns } from "./InviteCustomerModal.vue?vue&type=template&id=20a91cc4&"
import script from "./InviteCustomerModal.vue?vue&type=script&lang=js&"
export * from "./InviteCustomerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports